var exports = {
  "ed": "PurchaseDisclaimer.module__disclaimer___N3Z3dE",
  "gX": "PurchaseDisclaimer.module__center___N3Z3dE",
  "kb": "PurchaseDisclaimer.module__left___N3Z3dE",
};

module.exports = exports;
